import { useEffect, useState } from "react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { getConsent, setConsent } from "@/lib/cookieConsent";

export default function CookiePreferencesDialog({ open, onOpenChange }) {
  const [analytics, setAnalytics] = useState(true);

  useEffect(() => {
    if (open) setAnalytics(getConsent() !== "declined");
  }, [open]);

  const save = () => {
    setConsent(analytics ? "accepted" : "declined");
    toast.success("Cookie preferences saved");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="cookie-preferences-dialog" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-serif-display text-2xl">Cookie Preferences</DialogTitle>
          <DialogDescription>
            Control how cookies are used on blezzings.co. Your choice is saved on
            this device and can be changed at any time.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-5 py-2">
          <div className="flex items-start justify-between gap-6">
            <div>
              <div className="text-sm font-medium text-zinc-900">Essential</div>
              <p className="mt-1 text-xs text-zinc-500 leading-relaxed">
                Required for the website to function — including remembering your
                cookie preferences. Always on.
              </p>
            </div>
            <Switch checked disabled data-testid="cookie-essential-switch" aria-label="Essential cookies always on" />
          </div>

          <div className="flex items-start justify-between gap-6 border-t border-zinc-200 pt-5">
            <div>
              <div className="text-sm font-medium text-zinc-900">Analytics</div>
              <p className="mt-1 text-xs text-zinc-500 leading-relaxed">
                Google Analytics cookies that help us understand how visitors use
                the site, so we can improve it. No advertising or cross-site
                tracking.
              </p>
            </div>
            <Switch
              checked={analytics}
              onCheckedChange={setAnalytics}
              data-testid="cookie-analytics-switch"
              aria-label="Toggle analytics cookies"
            />
          </div>
        </div>

        <button
          type="button"
          onClick={save}
          data-testid="cookie-save-btn"
          className="inline-flex items-center justify-center h-11 px-6 bg-black text-white text-sm font-medium hover:bg-zinc-800 transition-colors duration-300"
        >
          Save Preferences
        </button>
      </DialogContent>
    </Dialog>
  );
}
